export default {
  name: 'wisk-chevron-right',
  width: 35,
  height: 35,
  paths: [{ d: 'M7.117,31.837a3.155,3.155,0,0,1,.937-2.248L20.262,17.5,8.054,5.411a3.164,3.164,0,0,1,4.453-4.5L26.984,15.252a3.259,3.259,0,0,1,0,4.5L12.507,34.085a3.164,3.164,0,0,1-5.39-2.248Z' }]
}
